import React from "react";
import Header from "../Header";
import Footer from "../Footer";
import { Row, Layout, Col, Spin, notification, Button, Empty, Modal } from "antd";
import { connect } from "react-redux";
import "./style.scss";
import CompanyInfo from "./CompanyInfo";
import _ from "lodash";
import moment from "moment";
import AddNewProjectModal from "../Header/AddNewProjectModal";
import AddNewAdModal from "../Header/AddNewAdModal";
import { addNewProject, allCotracts } from "../../store/actions/company/projects";
const { Content } = Layout;

class CompanyDetails extends React.Component {
  state = {
    moreAds: "",
    postJobPopup: false,
    newAdPopUp: false,
    addProject: false,
    nonProjectsExistModal: false,
    error: false,
    projectName: "",
    projectDescription: "",
  };
  async componentDidMount() {
    const { getCompanyInfo, getCompanyStatistic, getCompanyAds, getContracts } = this.props;

    try {
      await Promise.all([
        getCompanyInfo(),
        getCompanyStatistic(),
        getCompanyAds(),
      ]);
      
      if (getContracts) {
        getContracts();
      }
    } catch (error) {
      console.log(error);

      notification.error({
        message: "حدث خطأ ما",
      });
    }
  }

  onClose = () => {
    this.setState({
      postJobPopup: false,
      newAdPopUp: false,
      addProject: false,
      nonProjectsExistModal: false,
      error: false,
    });
  };

  postJob = () => {
    this.setState({
      addProject: false,
      nonProjectsExistModal: false,
      postJobPopup: true,
    });
  };

  NonExistProjectNewAd = async () => {
    const { getContracts } = this.props;
    if (getContracts) {
      await getContracts();
    }
    this.setState({
      postJobPopup: false,
      addProject: false,
      newAdPopUp: true,
    });
  };

  newAd = () => {
    const { addProject } = this.props;
    const { projectName, projectDescription } = this.state;
    if (
      !projectName ||
      !projectDescription ||
      /^\s*$/.test(projectName) ||
      /^\s*$/.test(projectDescription)
    ) {
      this.setState({
        error: true,
      });
    } else {
      if (addProject) {
        addProject({
          projectName,
          projectDescription,
        });
      }
      this.setState({
        postJobPopup: false,
        addProject: false,
        newAdPopUp: true,
      });
    }
  };

  render() {
    const { company, contracts } = this.props;
    const { error, nonProjectsExistModal } = this.state;
    const hasNoProjects = !company.companyAds || company.companyAds.length === 0;
    
    return (
      <div>
        <Header />
        <div className="user-container">
          <Content className="user-home">
            {/* <div className="user-notification">
              <Alert
                message="يوجد متقدم جديد  ياسر القحطاني على مشروع موقع للإنطلاق الجديد"
                type="warning"
                className="warning-alert"
              />
              <Alert
                message="يوجد متقدم جديد  سامر الأحمد على مشروع الشركة الرئيسية"
                type="info"
                className="info-alert"
              />
            </div> */}
            <Row className="company-progress" gutter={16}>
              <Col md={7} lg={7} xl={7} sm={7} className="opened-projects">
                <div>المشاريع المنشئة</div>
                <div className="user-stc-number">
                  {company.companyStatistic
                    ? company.companyStatistic.projects
                    : "0"}
                </div>
              </Col>
              <Col md={7} lg={7} xl={7} sm={7} className="total-offers">
                <div>عروض العمل الإجمالية</div>
                <div className="user-stc-number">
                  {company.companyStatistic
                    ? company.companyStatistic.jobs
                    : "0"}
                </div>
              </Col>
              <Col md={7} lg={7} xl={7} sm={7} className="user-hired">
                <div>الذين تم توظيفهم</div>
                <div className="user-stc-number">
                  {company.companyStatistic
                    ? company.companyStatistic.acceptes
                    : "0"}
                </div>
              </Col>
            </Row>
            <Row className="user-profile">
              <Col md={1}></Col>
              <Col
                md={6}
                lg={6}
                xl={6}
                sm={24}
                xs={24}
                className="right-section"
              >
                <CompanyInfo {...company} />
              </Col>
              <Col md={1}></Col>
              <Col
                md={15}
                lg={15}
                xl={15}
                sm={24}
                xs={24}
                className="company-left-section"
              >
                <h2>آخر العروض الوظيفية التي أنشئتها</h2>
                {hasNoProjects ? (
                  <div className="empty-state-container" style={{ 
                    textAlign: 'center', 
                    padding: '40px 0',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <Empty
                      description="لايوجد لديك آي مشاريع و عروض وظيفية"
                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                    />
                    <Button 
                      type="primary" 
                      size="large"
                      onClick={this.postJob}
                      style={{ marginTop: '20px' }}
                    >
                      إضافة مشروع جديد
                    </Button>
                  </div>
                ) : (
                  <>
                    <div className="projects-offers-header">
                      <div>اسم العرض الوظيفي</div>
                      <div>التاريخ</div>
                      <div>اسم المشروع</div>
                      <div>عدد المتقدمين</div>
                      <div>المتقدمين</div>
                    </div>
                    {company.companyAds.map((elm) => {
                      return (
                        <div className="project-offer" key={elm.advId}>
                          <div className="project-offer-title">{elm.advName}</div>
                          <div>{moment(Date.now()).format("ll")}</div>
                          <div className="project-status">{elm.projectName}</div>
                          <div>
                            <div className="applicants-num">{elm.candidates}</div>
                          </div>
                          <div
                            className="applicants-col"
                            onClick={() =>
                              this.props.history.push(
                                `/applicants/job/id=${elm.advId}&name=${elm.advName}`
                              )
                            }
                          >
                            {" "}
                            عرض
                          </div>
                        </div>
                      );
                    })}
                  </>
                )}
              </Col>
            </Row>
          </Content>
        </div>
        <Footer />
        
        <AddNewProjectModal
          postJobPopup={this.state.postJobPopup}
          newAd={this.newAd}
          onChange={(e) => {
            this.setState({ [e.target.name]: e.target.value });
          }}
          closable={this.onClose}
          error={error}
        />
        
        <Modal
          visible={nonProjectsExistModal}
          closable={true}
          footer={false}
          className="ad-modal"
          onCancel={this.onClose}
        >
          <div className="non-exist-project-modal">
            <h3> يجب عليك اضافة مشروع أولا</h3>
            <h3>هل ترغب في اضافة مشروع جديد؟</h3>
            <button onClick={this.postJob}>اضافة مشروع جديد</button>
          </div>
        </Modal>

        <AddNewAdModal
          newAdPopUp={this.state.newAdPopUp}
          contractsTypes={contracts}
          history={this.props.history}
          closable={this.onClose}
        />
      </div>
    );
  }
}

const mapStateToProps = ({ companyProjects }) => {
  return {
    contracts: companyProjects,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addProject: (params) => dispatch(addNewProject(params)),
    getContracts: () => dispatch(allCotracts()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CompanyDetails);
